import derivedValuesFromSelection from "components/financials/modern/selection/derivedValuesFromSelection";
import type { IndicatorSelection } from "components/financials/modern/types";
import classNames from "components/ui/classNames";
import { TrendingDownIcon, TrendingUpIcon } from "lucide-react";

interface SelectedIndicatorTrendIconProps {
  selection: IndicatorSelection[];
}
export default function SelectedIndicatorTrendIcon({ selection }: SelectedIndicatorTrendIconProps) {
  if (selection.length < 2) {
    return null;
  }

  const derivedSelectionValues = derivedValuesFromSelection(selection);
  if (!derivedSelectionValues) {
    return null;
  }
  const { variation } = derivedSelectionValues;

  return (
    <div
      aria-hidden={true}
      className={classNames("inline-flex items-center justify-center p-2 text-white squircle", {
        "bg-red-50 text-red-700 dark:bg-red-950 dark:text-red-300": variation < 0,
        "bg-emerald-50 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300": variation > 0,
        hidden: variation === 0,
      })}
    >
      {variation > 0 && <TrendingUpIcon strokeWidth={2.5} className="h-4 w-4" />}
      {variation < 0 && <TrendingDownIcon strokeWidth={2.5} className="h-4 w-4" />}
    </div>
  );
}
